import { EventEmitter } from '@angular/core';
import { GenericListIconButtonClickHandlerData } from './generic-list-icon-button-click-handler-data';

export class GenericListIconButtonDefinition {
  buttonColor: string;
  icon: string;
  data: any;
  clickHandler: EventEmitter<GenericListIconButtonClickHandlerData>;
  disabled = false;

  constructor(data: any, clickHandler: EventEmitter<GenericListIconButtonClickHandlerData>, icon: string, buttonColor = 'primary', disabled?: boolean) {
    this.buttonColor = buttonColor;
    this.icon = icon;
    this.data = data;
    this.clickHandler = clickHandler;
    this.disabled = disabled;
  }
}
